import { useState } from "react";
import PujaList from "../components/pujaList";
import PujaSearchBox from "../components/pujaSearchBox";
import { getAllCommunityEvents, getSearchedCommunityEvent } from "../queries/pujas.queries";
const PujaListView = ({
  data
}) => {
  const [pujasState, setPujasState] = useState(data);
  const [pujaPage, setPujaPage] = useState(0);
  const [search, setSearch] = useState("");
  const [hasMorePujas, setHasMorePujas] = useState(true);
  const [loading, setLoading] = useState(false);
  async function updateData() {
    let response = null;
    if (search === "" || search === null) {
      //console.log("searchObj 1", searchObj);
      response = await getAllCommunityEvents({
        page: pujaPage + 1
      });
    } else {
      //console.log("searchObj 2", searchObj);
      response = await getSearchedCommunityEvent({
        search: search,
        page: pujaPage + 1
      });
    }
    if (!response.err && response.data) {
      if (response.data.length === 0) {
        setHasMorePujas(false);
      } else {
        setPujasState(currentData => [...currentData, ...response.data]);
        setPujaPage(cur => cur + 1);
        setHasMorePujas(true);
      }
    } else {
      setHasMorePujas(false);
    }
  }
  return <>
      <PujaSearchBox setHasMorePujas={setHasMorePujas} setPujasState={setPujasState} search={search} setSearch={setSearch} pujaPage={pujaPage} setPujaPage={setPujaPage} setLoading={setLoading} loading={loading} data-sentry-element="PujaSearchBox" data-sentry-source-file="pujaListView.jsx" />

      <PujaList pujas={pujasState} updateData={updateData} hasMore={hasMorePujas} data-sentry-element="PujaList" data-sentry-source-file="pujaListView.jsx" />
    </>;
};
export default PujaListView;